"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useIsAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useIsAuthenticated"));

var _DialogWithTitle = _interopRequireDefault(require("../../../components/DialogWithTitle"));

var _CompareIcon = _interopRequireDefault(require("../../../icons/CompareIcon"));

var _LinkIcon = _interopRequireDefault(require("../../../icons/LinkIcon"));

var _QuestionIcon = _interopRequireDefault(require("../../../icons/QuestionIcon"));

var _ServiceIcon = _interopRequireDefault(require("../../../icons/ServiceIcon"));

var _useShoppingRegion = _interopRequireDefault(require("../../../shop/useShoppingRegion"));

var _ProductDetailBarButtonCompare = _interopRequireDefault(require("./ProductDetailBarButtonCompare"));

var _ProductDetailBarButtonAddToFavorites = _interopRequireDefault(require("./ProductDetailBarButtonAddToFavorites"));

var _ProductDetailSendLink = _interopRequireDefault(require("./ProductDetailSendLink"));

var _ProductDetailBarButton = _interopRequireDefault(require("./ProductDetailBarButton"));

/* eslint-disable no-nested-ternary */
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    less: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      '& a': {
        width: '50%',
        borderRight: 'none',
        '&:first-of-type': {
          borderRight: '1px solid',
          borderRightColor: theme.palette.another.grey
        },
        '&:nth-of-type(3)': {
          borderBottom: 'none',
          borderRight: '1px solid',
          borderRightColor: theme.palette.another.grey
        },
        '&:nth-of-type(4)': {
          borderBottom: 'none'
        }
      }
    }),
    item: {},
    popupContent: {
      display: 'flex',
      alignItems: 'center'
    }
  };
}, {
  name: 'ProductDetailBar'
});
var serviceUrlOverride = {
  BG: 'https://www.digiexpert.bg/info/service',
  RO: 'https://www.digiexpert.ro/info/service',
  IT: '/info/contatti'
};

function ProductDetailBar(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var region = (0, _useShoppingRegion.default)();

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      openSendLinkDialog = _React$useState2[0],
      setOpenSendLinkDialog = _React$useState2[1];

  var isAuth = (0, _useIsAuthenticated.default)();

  var handleOpenSendLinkDialog = _react.default.useCallback(function (i) {
    return function () {
      setOpenSendLinkDialog(i);
    };
  }, []);

  var serviceURL = serviceUrlOverride[region] || product.manufacturer && product.manufacturer.extra && product.manufacturer.extra.serviceHref || {};
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className, !isAuth && classes.less)
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailBarButtonAddToFavorites.default, {
    product: product,
    classes: {
      root: classes.item
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailBarButtonCompare.default, {
    classes: {
      root: classes.item
    },
    icon: _CompareIcon.default,
    label: t('productDetail/productDetailBarInformation/compareProduct'),
    product: product
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailBarButton.default, {
    className: classes.item,
    icon: _LinkIcon.default,
    label: t('productDetail/productDetailBarInformation/sendLink'),
    onClick: handleOpenSendLinkDialog(true)
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailBarButton.default, {
    className: classes.item,
    icon: _ServiceIcon.default,
    label: t('productDetail/productDetailBarInformation/serviceList'),
    href: serviceURL
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailBarButton.default, {
    className: classes.item,
    icon: _QuestionIcon.default,
    label: t('productDetail/productDetailBarInformation/questions'),
    href: "#questions"
  }), /*#__PURE__*/_react.default.createElement(_DialogWithTitle.default, {
    fullWidth: true,
    title: t('productDetail/productDetailBarInformation/sendLink'),
    onChange: handleOpenSendLinkDialog,
    openDialog: openSendLinkDialog,
    maxWidth: "md"
  }, /*#__PURE__*/_react.default.createElement(_ProductDetailSendLink.default, {
    product: product,
    className: classes.popupContent
  })));
}

process.env.NODE_ENV !== "production" ? ProductDetailBar.propTypes = {
  classes: _propTypes.default.shape({
    item: _propTypes.default.string,
    less: _propTypes.default.string,
    popupContent: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string,
    manufacturer: _propTypes.default.shape({
      extra: _propTypes.default.shape({
        serviceHref: _propTypes.default.string
      })
    }),
    sku: _propTypes.default.string
  }).isRequired
} : void 0;
ProductDetailBar.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ProductDetailBar;
exports.default = _default;